import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { reorderWalletsRequestAction } from './wallet-requests'

import type { WalletId } from '../model'

export const reorderWalletsAction = action(
  async (ctx, { walletIds }: { walletIds: Array<WalletId> }) => {
    const network = ctx.get(selectedNetworkAtom)
    const result = await ctx.schedule(() =>
      reorderWalletsRequestAction(ctx, { network, walletIds }),
    )

    if (Result.isFailure(result)) {
      showSnackbarAction(ctx, {
        text: i18next.t('wallet.reorder_wallets.failure'),
        intent: 'error',
      })
    }
    return result
  },
  'reorderWalletsAction',
)
